module.exports = __webpack_public_path__ + "img/American_Credit_Business_Loans_Process_Loan_Money.5f1fb64.png";